import {
  Box, Flex, Link, Text,
} from '@chakra-ui/react';
import { TRAFFIC_LIGHT_COLOURS as COLOURS, publicTransportLegend } from '@src/modules/performance/shared/constants';
import {
  usePublicTransportKPI,
} from '@src/modules/performance/context/reports-api-hooks';

import { roundKpiValue } from '@src/modules/performance/shared/helpers';
import { CircleIndicator } from '@src/modules/performance/components/indicators';
import IndicatorLegend from '@src/modules/performance/components/IndicatorLegend';
import ReportHeader from './ReportHeader';

const subheader = 'Fleet Size, Network Use and Community Serviced';
const informationSource = {
  title: 'Public Transport and Total Mobility',
  content: [
    {
      title: 'Passenger km (% Year Annual Average)',
      description:
  <>
    <Text fontSize="inherit" mb={2}>
      The annual average growth in passenger-km travelled for the five years reported as a percentage of the start year total. Includes a trend as below:
    </Text>
    <IndicatorLegend items={publicTransportLegend} />
    <Text mb={2}>Road Efficiency Group Te Ringa Maimoa has calculated this result.</Text>
  </>,
      source:
  <Text fontSize="inherit" as="span">
    Sourced from
    {' '}
    <Link href="https://www.nzta.govt.nz/planning-and-investment/learning-and-resources/transport-data/data-and-tools/" isExternal>NZTA Data and Tools, use - public transport</Link>
  </Text>,
    },
  ],
};

function PublicTransportReportHeader({ ...rest }) {
  const { data: publicTransportData, isLoadingKpi } = usePublicTransportKPI();

  return (
    <ReportHeader
      title="Public Transport and Total Mobility"
      subtitle={subheader}
      informationSource={informationSource}
      {...rest}
    >
      <Flex align="center">
        <Box mr={3}>
          <CircleIndicator
            size={60}
            colour={COLOURS[publicTransportData?.colour]}
            value={(publicTransportData?.value !== undefined && publicTransportData?.value) ? `${roundKpiValue(publicTransportData?.value, 5, 1)}%` : null}
            isLoading={isLoadingKpi && !publicTransportData}
          />
        </Box>
        <Text fontWeight="bold" color="gray" fontSize="sm">
          Passenger km
          <br />
          <Text as="span" fontSize="xs" color="gray">
            (
            {publicTransportData?.averageYearRange}
            {' '}
            Annual Avg & Trend)
          </Text>
        </Text>
      </Flex>
    </ReportHeader>
  );
}

export default PublicTransportReportHeader;
